import { render, staticRenderFns } from "./LoopItemPanel.vue?vue&type=template&id=53e88f18&"
import script from "./LoopItemPanel.vue?vue&type=script&lang=js&"
export * from "./LoopItemPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports